/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type CompanyPaginatedProperty =
  typeof CompanyPaginatedProperty[keyof typeof CompanyPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyPaginatedProperty = {
  CREATED_AT: 'CREATED_AT',
} as const;
